import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box, Grid, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../../../commons/formik/formikTextField";
import CircularLoading from "../../../../../commons/loadingData/circularLoading";
import moment from "moment";

const validationSchema = Yup.object().shape({
  observacion: Yup.string().required("La observación es obligatoria"),
});

const ObservacionesDialogPT = ({ open, handleClose, tramo, observaciones, handleSubmit }) => {
  if (!tramo) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#5b9bf5", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="subtitle1">OBSERVACIONES  TRASLADO {tramo.nroTraslado}</Typography>
        <IconButton onClick={handleClose} sx={{ color: "#fff" }} size="small"><CloseIcon /></IconButton>
      </DialogTitle>

      <Formik
        initialValues={{
          observacion: ""
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent dividers>

              {observaciones.isFetching ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                  <CircularLoading />
                </Box>
              ) : (
                <>
                  {observaciones.data && observaciones.data.length > 0 &&
                    <>
                      <Typography variant="h6" sx={{ color: "#5b9bf5", mb: 1 }}>Observaciones anteriores</Typography>
                      <Box sx={{ height: "2px", backgroundColor: "#5b9bf5", mb: 3 }} />
                    </>
                  }

                  {observaciones.data && observaciones.data.map((obs, i) => (
                    <Box key={i} sx={{ borderLeft: "3px solid #dde2e7", pl: 2, mb: 2 }}>
                      <Typography variant="body2" color="textPrimary">{obs.observacion}</Typography>
                      <Typography variant="caption" color="textSecondary">{moment(obs.fechaHoraCreacion).format("DD/MM/YYYY HH:mm")}  {obs.usuarioCreacion}</Typography>
                    </Box>
                  ))}
                </>
              )}

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikTextField
                    name="observacion"
                    label="Nueva observación *"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={handleClose} color="primary" disabled={isSubmitting}>CANCELAR</Button>
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "AGREGAR"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ObservacionesDialogPT;
